import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const VerificationCodeInputContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
}));

export const CustomTextField = styled(TextField)(({ theme }) => ({
    display: "flex",
    width: theme.space._750,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._200,
    backgroundColor: theme.colors['neutral.900'],
    borderRadius: "8px",
    cursor: "pointer",
    '& .MuiInputBase-input': {
      color: theme.colors['neutral.400'],
      fontFamily: theme.fonts.default,
      fontSize: theme.fontSizes.md,
      fontWeight: theme.fontWeights.medium,
      lineHeight: theme.lineHeights.short,
      height: "20px",
      borderRadius: "8px",
      '&.Mui-disabled': {
        WebkitTextFillColor: theme.colors['neutral.400'],
        cursor: "not-allowed",
        opacity: theme.opacity.light,
        pointerEvents: "auto"
      }
    },
  
    '& .MuiInputBase-root': {
      color: theme.colors['neutral.400'],
      '& fieldset': {
        borderRadius: "8px",
  
      },
      '&:hover fieldset': {
        borderColor: theme.colors['neutral.500'],
        borderRadius: "8px",
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.colors['blue.400'],
        borderRadius: "8px",
      },
    },
  
    '&.is-error': {
      '& .MuiInputBase-root': {
        '& fieldset': {
          borderColor: theme.colors['red.700'],
        },
        '&:hover fieldset': {
          borderColor: theme.colors['red.500'],
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.colors['red.700'],
        },
      },
    }
  }));

